/* eslint-disable no-underscore-dangle */
import React from 'react';
import { SbEditableContent } from 'storyblok-react';
import { blokToComponent } from '../../../../helpers';
import { Props } from '../../../../types';

type PageProps = Props<{ body: SbEditableContent[] }>;

const parseGridsIntoSlider = (uid: string, grids: SbEditableContent[]) => ({
  _uid: `${uid}-further-content-grid`,
  component: 'roche-grid-12',
  remove_padding_top: true,
  color: 'theme-aware',
  full_width: false,
  slotted: [{
    _uid: `${uid}--further-content-slider`,
    component: 'roche-slider',
    slides_per_page: 3,
    slotted: grids
      .flatMap((grid) => [grid.slotted_left, grid.slotted_center, grid.slotted_right])
      .map((slotted, index) => {
        if (!slotted.length) return null;
        return {
          _uid: `${uid}-slider-item-${index}`,
          component: 'roche-slider-item',
          slotted,
        };
      })
      .filter(Boolean),
  }],
});

export const DownloadSection = ({ blok, getComponent }: PageProps) => {
  const hasDownloads = !!blok.downloads?.length;
  if (!hasDownloads) return <></>;

  const grids = blok.downloads?.map((grid: SbEditableContent) => ({
    ...grid,
    color: 'theme-aware',
    full_width: false,
  })) || [];

  const anchor = {
    _uid: `${blok._uid}-download-anchor`,
    component: 'roche-anchor-navigation-target',
    target_id: 'downloads',
  };

  const headline = {
    _uid: `${blok._uid}-download-headline`,
    component: 'roche-headline',
    headline: 'Downloads',
    level: 2,
  };

  const downloads = blok.downloads.length >= 2
    ? parseGridsIntoSlider(blok._uid, grids)
    : grids[0];

  return <>
    {blokToComponent({
      blok: {
        _uid: `${blok._uid}-download-headline-grid`,
        component: 'roche-grid-12',
        color: 'theme-aware',
        slotted: [headline, anchor],
      },
      getComponent,
    })}

    {blokToComponent({
      blok: downloads,
      getComponent,
    })}
  </>;
};
